import UsersIndex from "./UsersIndex.vue";
import UsersAdd from "./UsersAdd.vue";
import UsersDetail from "./UsersDetail.vue";
import UsersEdit from "./UsersEdit.vue";

let routesUsersAccess= [
    {
        path: '',
        meta: {
          title: "List User Mapping",
        },
        name: "UserMappingIndex",
        component: UsersIndex
    },
    {
        path: 'create',
        meta: {
          title: "Create User Mapping",
        },
        name: "UserMappingAdd",
        component: UsersAdd
    },
     
    {
        path: 'detail/:id',
        meta: {
          title: "Detail User Mapping",
        },
        name: "UserMappingDetail",
        component: UsersDetail
    },
     
    {
        path: 'edit/:id',
        meta: {
          title: "Edit User Mapping",
        },
        name: "UserMappingEdit",
        component: UsersEdit
    },
    
]

export default routesUsersAccess
  